import i18n from "locales/i18n";

type FormatPriceArguments = {
  value: number;
  currency: string;
};

export const formatPrice = ({ value, currency }: FormatPriceArguments) => {
  if (!currency) {
    console.warn("formatPrice called with invalid currency:", currency);
    
return value.toString(); // or throw an error / return empty string
  }

  const locale = i18n.language;
  const parts = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 0,
  }).formatToParts(value);

  return parts
    .map(({ value: partValue }) => (partValue === "KWD" ? "KD" : partValue))
    .join("");
};
